import React from 'react'
import { useSelector } from 'react-redux'

import { selectSelectedSubmissionView } from 'state/review'
import { SUBMISSION_VIEW_ENUM } from 'state/submissions'
import SimpleTable from './SimpleTable'
import SubmissionList from './SubmissionList'
import { HandleEditTagChange, HandleRejectTagChange } from 'components/utils/review'

interface SubmissionsContainerProps {
    handleEditTagChange: HandleEditTagChange
    handleRejectTagChange: HandleRejectTagChange
    tableHeight: string
}

const SubmissionsContainer: React.FC<SubmissionsContainerProps> = ({
    tableHeight,
    handleEditTagChange,
    handleRejectTagChange,
}) => {
    const submissionView = useSelector(selectSelectedSubmissionView)

    switch (submissionView) {
        case SUBMISSION_VIEW_ENUM.REJECTED:
        case SUBMISSION_VIEW_ENUM.DROPOUTS:
            return <SimpleTable viewType={submissionView} />
        default:
            return (
                <SubmissionList
                    handleEditTagChange={handleEditTagChange}
                    handleRejectTagChange={handleRejectTagChange}
                    tableHeight={tableHeight}
                />
            )
    }
}

export default SubmissionsContainer
